import { Controller } from "@hotwired/stimulus"

// Populates the topic dropdown from the selected program (program -> topic cascade),
// mirroring the book -> asset cascade on the question generation form.
//
// Also sniffs the chosen JSON file: a multi-topic file (top-level `topics` array)
// names its own topics, so the topic select is disabled and a note explains that
// only the program is needed. The server re-detects the shape on submit either way.
export default class extends Controller {
  static targets = ["programSelect", "topicSelect", "fileInput", "modeNote"]

  async programChanged(event) {
    const programId = event.target.value
    const select = this.topicSelectTarget

    if (!programId) {
      select.innerHTML = '<option value="">Select a program first...</option>'
      select.disabled = true
      return
    }

    const response = await fetch(`/exercise/question_imports/topics?program_id=${programId}`, {
      headers: { "Accept": "application/json" }
    })
    const topics = await response.json()

    if (topics.length === 0) {
      select.innerHTML = '<option value="">No topics in this program</option>'
      select.disabled = true
      return
    }

    select.innerHTML = '<option value="">Select a topic...</option>'
    topics.forEach(topic => {
      const option = document.createElement("option")
      option.value = topic.id
      option.textContent = topic.name
      select.appendChild(option)
    })
    select.disabled = !!this.multiTopicFile
  }

  async fileChanged(event) {
    const file = event.target.files[0]
    this.multiTopicFile = false

    if (file) {
      try {
        const data = JSON.parse(await file.text())
        if (Array.isArray(data.topics)) {
          this.multiTopicFile = true
          const names = data.topics.map(t => t && t.name).filter(Boolean)
          this.showModeNote(
            `Multi-topic file: ${names.length} topics will be matched by name or created ` +
            `in the selected program — no topic selection needed.`
          )
        }
      } catch {
        // Not parseable here — let the server report the JSON error on submit.
      }
    }

    if (!this.multiTopicFile) this.hideModeNote()
    this.topicSelectTarget.disabled = this.multiTopicFile || !this.programSelectTarget.value
    if (this.multiTopicFile) this.topicSelectTarget.value = ""
  }

  showModeNote(text) {
    this.modeNoteTarget.textContent = text
    this.modeNoteTarget.classList.remove("d-none")
  }

  hideModeNote() {
    this.modeNoteTarget.classList.add("d-none")
  }
}
